'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var index = require('../index-784ff647.js');
var transformTRPCResponse = require('../transformTRPCResponse-e65f34e9.js');
var getCauseFromUnknown = require('../getCauseFromUnknown-d535264a.js');
require('../codes-87f6824b.js');



exports.createFlatProxy = index.createFlatProxy;
exports.createRecursiveProxy = index.createRecursiveProxy;
exports.getErrorShape = transformTRPCResponse.getErrorShape;
exports.transformTRPCResponse = transformTRPCResponse.transformTRPCResponse;
exports.getCauseFromUnknown = getCauseFromUnknown.getCauseFromUnknown;
